import { FC } from 'react';
import { CHANNEL_CODE_LEGEND } from '../utils/fundingPartners';

type ReferralCodeLegendProps = {
  className?: string
};

/** Monospace referral-code format template (HC-{channel}-{partner}-{hex}). */
export const ReferralCodeLegend: FC<ReferralCodeLegendProps> = ({ className = '' }) => (
  <code
    className={`font-mono text-xs font-semibold tracking-wide text-primary-100 bg-[#F8FCFD] border border-primary-400/35 rounded px-2 py-0.5 ${className}`}
    data-testid="referral-code-legend"
  >
    {CHANNEL_CODE_LEGEND}
  </code>
);
